import React from 'react';
import PropTypes from 'prop-types';

import {
  LabelWidget,
  ErrorChangeWidget,
} from '../../widgets';

import { Spinner } from '../../base';
import { Grid, Cell } from '../../base/styled';

const TopErrorsByDeviation = (props) => {

  if (props.errorChangeData === undefined && props.adsData === undefined && props.cmsData === undefined) {
    return (<Spinner />);
  }

  const {
    title = '',
    subtitle = '',
    errorChangeData: {
      error: errorChangeError = null,
      data: errorChangeDataArray = [],
    } = {},
    adsData: {
      error: adsError = null,
      data: adsData = [],
    } = {},
    cmsData: {
      error: tracebacksError = null,
      data: tracebacksData = [],
    } = {},
  } = props;

  let limit = 15;
  if (adsError || adsData.length) {
    limit--;
  }
  if (tracebacksError || tracebacksData.length) {
    limit--;
  }
  const widgetList = errorChangeDataArray.slice(0, limit).map((e, i) => (
    errorChangeError ? ({
      error: errorChangeError,
      data: null,
      key: `widget ${i}`,
    }) : ({
      data: e,
      key: `widget ${i}`,
    })));

  if (adsError || adsData.length) {
    widgetList.push({
      key: `widget ${widgetList.length}`,
      error: adsError,
      data: adsData.length ? adsData[0] : null,
    });
  }
  if (tracebacksError || tracebacksData.length) {
    widgetList.push({
      key: `widget ${widgetList.length}`,
      error: tracebacksError,
      data: tracebacksData.length ? tracebacksData[0] : null,
    });
  }

  while (widgetList.length < 15) {
    widgetList.push({
      error: null,
      data: {
        title: '',
        subtitle: '',
        details: '',
        affected: 0,
        hideAffected: false,
        className: 'empty',
      },
    });
  }

  widgetList.forEach((e, i) => { e.key = i; });

  return (
    <div className="dashboard">
      <Grid columns={5} rows="75px 1fr 1fr 1fr" alignContent="stretch" height="inherit">
        <Cell width={5}>
          <LabelWidget input={{ data: { title, subtitle } }} />
        </Cell>
        {
          widgetList.map(widget => (
            <Cell width={1} key={widget.key}>
              <ErrorChangeWidget input={widget} />
            </Cell>
          ))
        }
      </Grid>
    </div>
  );
};

TopErrorsByDeviation.defaultProps = null;

TopErrorsByDeviation.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  errorChangeData: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({ errorChangeWidgets: PropTypes.arrayOf(ErrorChangeWidget.dataPropType) }),
  }),
  adsData: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({ errorChangeWidgets: PropTypes.arrayOf(ErrorChangeWidget.dataPropType) }),
  }),
  cmsData: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({ errorChangeWidgets: PropTypes.arrayOf(ErrorChangeWidget.dataPropType) }),
  }),
};

export default TopErrorsByDeviation;
